<ng-container *ngIf="!isShareholder">
    <div class="container text-center">
        <h2>{{'Find your local reseller' | translate}}</h2>
    </div>


    <app-stepper></app-stepper>

    <app-step1 *ngIf="step === 1"></app-step1>
    <app-step2 *ngIf="step === 2"></app-step2>
    <app-step3 *ngIf="step === 3"></app-step3>
</ng-container>

<ng-container *ngIf="isShareholder">
    <app-shareholders-form></app-shareholders-form>
</ng-container>
